if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonLabel =
          this.submitButton.querySelector('[data-atc-label]') || this.submitButtonText;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const redirectType = this.submitButton.dataset.redirectType;
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const offerKey =
          this.form.querySelector('input[name="bundle_offer"]:checked')?.value ||
          document.querySelector('input[name="bundle_offer"]:checked')?.value;

        const bundle = window?.lgd?.checkout?.bundles?.[offerKey];
        const formEl = this.form;

        const getOrCreateDiscountInput = () => {
          let di = formEl.querySelector('input[name="discount"]');
          if (!di) {
            di = document.createElement('input');
            di.type = 'hidden';
            di.name = 'discount';
            di.setAttribute('data-lgd-injected', 'true');
            formEl.appendChild(di);
          }
          return di;
        };

        const removeAnyDiscount = () => {
          formData.delete('discount');
          const anyDiscountEl = formEl.querySelector('input[name="discount"]');
          if (anyDiscountEl) anyDiscountEl.remove();
        };

        const removeInjectedDiscountOnly = () => {
          formData.delete('discount');
          const injected = formEl.querySelector('input[name="discount"][data-lgd-injected="true"]');
          if (injected) injected.remove();
        };

        if (bundle && offerKey) {
          const code = String(bundle.discount_code || '').trim();
          if (code) {
            const di = getOrCreateDiscountInput();
            di.value = code;

            if (formData.has('discount')) formData.set('discount', code);
            else formData.append('discount', code);
          } else {
            removeAnyDiscount();
          }
        } else {
          removeInjectedDiscountOnly();
        }

        if (bundle?.parent_variant_id) {
          const parentIdNum = parseInt(bundle.parent_variant_id, 10);
          if (Number.isFinite(parentIdNum) && parentIdNum > 0) {
            const parentId = String(parentIdNum);

            const idInput = this.form.querySelector('input[name="id"]');
            if (idInput) idInput.value = parentId;

            if (formData.has('id')) formData.set('id', parentId);
            else formData.append('id', parentId);
          }
        }

        if (bundle && !bundle.parent_selling_plan_id) {
          formData.delete('selling_plan');
          const spEl = this.form.querySelector('input[name="selling_plan"]');
          if (spEl) spEl.remove();
        }

        if (bundle?.parent_selling_plan_id) {
          const spNum = parseInt(bundle.parent_selling_plan_id, 10);
          if (Number.isFinite(spNum) && spNum > 0) {
            const spVal = String(spNum);

            let spEl = this.form.querySelector('input[name="selling_plan"]');
            if (!spEl) {
              spEl = document.createElement('input');
              spEl.type = 'hidden';
              spEl.name = 'selling_plan';
              this.form.appendChild(spEl);
            }
            spEl.value = spVal;

            if (formData.has('selling_plan')) formData.set('selling_plan', spVal);
            else formData.append('selling_plan', spVal);
          }
        }

        let id = this.form.querySelector('[name="id"]')?.value || formData.get('id');

        const digitalProduct = window?.lgd?.checkout?.nestedDigitalProducts;
        const digitalShippingProduct = window?.lgd?.checkout?.digitalShippingProduct;

        const hasDigitalChild = Boolean(id) && digitalProduct && digitalProduct.includes(parseInt(id, 10));

        if (hasDigitalChild) {
          formData.append('items[1][id]', String(digitalShippingProduct));
          formData.append('items[1][quantity]', 1);
          formData.append('items[1][parent_id]', String(id));
        }

        const baseQty = parseInt(formData.get('quantity') || '1', 10) || 1;

        if (bundle && offerKey && id) {
          const bookQtyMultiplier = parseInt(bundle.bookQty || 1, 10) || 1;
          const finalBookQty = baseQty * bookQtyMultiplier;

          if (formData.has('quantity')) formData.set('quantity', String(finalBookQty));
          else formData.append('quantity', String(finalBookQty));

          let nextIdx = hasDigitalChild ? 2 : 1;
          for (const [k] of formData.entries()) {
            const m = String(k).match(/^items\[(\d+)\]\[id\]$/);
            if (m) nextIdx = Math.max(nextIdx, Number(m[1]) + 1);
          }

          (bundle.items || []).forEach((it) => {
            if (!it?.id) return;

            if (String(it.id) === String(id)) return;
            if (hasDigitalChild && String(it.id) === String(digitalShippingProduct)) return;

            const itemQty = (parseInt(it.quantity || 1, 10) || 1) * finalBookQty;

            formData.append(`items[${nextIdx}][id]`, String(it.id));
            formData.append(`items[${nextIdx}][quantity]`, String(itemQty));
            formData.append(`items[${nextIdx}][parent_id]`, String(id));

            if (it.selling_plan) {
              formData.append(`items[${nextIdx}][selling_plan]`, String(it.selling_plan));
            }

            formData.append(`items[${nextIdx}][properties][_lgd_bundle_offer]`, offerKey);
            formData.append(`items[${nextIdx}][properties][_lgd_bundle_title]`, bundle.title || offerKey);

            nextIdx += 1;
          });
        }

        const upsellMax = 2;

        let upsellChecked = Array.from(this.form.querySelectorAll('[data-lgd-upsell-checkbox]:checked'));
        if (!upsellChecked.length) {
          upsellChecked = Array.from(document.querySelectorAll('[data-lgd-upsell-checkbox]:checked'));
        }

        const upsellVariantIds = Array.from(
          new Set(upsellChecked.map((el) => el.getAttribute('data-variant-id')).filter(Boolean)),
        ).slice(0, upsellMax);

        if (upsellVariantIds.length > 0 && id) {
          let nextIdx = hasDigitalChild ? 2 : 1;
          for (const [k] of formData.entries()) {
            const m = String(k).match(/^items\[(\d+)\]\[id\]$/);
            if (m) nextIdx = Math.max(nextIdx, Number(m[1]) + 1);
          }

          upsellVariantIds.forEach((variantId) => {
            if (String(variantId) === String(id)) return;
            if (hasDigitalChild && String(variantId) === String(digitalShippingProduct)) return;
            formData.append(`items[${nextIdx}][id]`, String(variantId));
            formData.append(`items[${nextIdx}][quantity]`, '1');
            formData.append(`items[${nextIdx}][properties][_lgd_upsell]`, 'true');
            nextIdx += 1;
          });
        }
        const funnelSourceCheck = this.form.querySelector('[name="properties[_funnel_source]"]')?.value;
        let cartClearPromise = Promise.resolve();

        if (funnelSourceCheck == 'livingood-daily-approved-book-pre-order') {
          cartClearPromise = fetch('/cart/clear.js', {
            method: 'POST',
          })
            .then((response) => response.json())
            .then((data) => {
              console.log('Cart cleared:', data);
            })
            .catch((error) => {
              console.error('Error clearing cart:', error);
            });
        }

        cartClearPromise
          .then(() => {
            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id),
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;

            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              const desc = String(response.description || '');
              if (offerKey && desc.toLowerCase().includes('cannot find variant')) {
                this.handleErrorMessage(
                  'Bundle setup error: Check that all IDs are VARIANT IDs and that no invalid selling_plan is being sent.',
                );
              } else {
                this.handleErrorMessage(response.description);
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              const funnelSource = this.form.querySelector('[name="properties[_funnel_source]"]')?.value;
              if (funnelSource) {
                const discountCode = this.form.querySelector('[name="discount"]')?.value;
                if (discountCode) {
                  window.location = `/checkout?discount=${discountCode}`;
                  return;
                } else {
                  window.location = '/checkout';
                  return;
                }
              } else {
                if (funnelSource) {
                  window.location = '/checkout';
                  return;
                } else {
                  window.location = window.routes.cart_url;
                  return;
                }
              }
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              if (redirectType === 'checkout') {
                const discountCode = this.form.querySelector('[name="discount"]')?.value;
                if (discountCode) {
                  window.location = `/checkout?discount=${discountCode}`;
                } else {
                  window.location = '/checkout';
                }
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonLabel.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (!window.location.pathname.includes('livingood-daily-lifestyle')) {
            this.submitButtonLabel.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    },
  );
}
